import {TimeAccountBase, TimeAccountDashboardConfig} from "./timeAccountBase";
import {TimeAccountTable} from "@/features/timeaccounts/timeAccountTable";
import * as TimeVacationAccountInfo from "@/features/timeaccounts/timeVacationAccountInfo";
import {BrowserStorageSettings} from "@/shared/browserStorageSettings";
import {TimeAccountDashboardBalanceMode, TimeAccountVacationData} from "@/shared/timr";


export class MyTimeAccountPage extends TimeAccountBase {

	constructor(config: TimeAccountDashboardConfig) {
		config.timeAccountViewType = "MY_ACCOUNT";
		super(config);

		this.timeAccountTable = new TimeAccountTable({
			element: $("#timeAccountTable"),
			initialFilter: TimeAccountTable.buildFilterParams(null, globals.userId, null),
			timeAccountBalanceChanged: () => {
				this.reloadCurrentTimeAccountData();
			},
			orderable: false,
			clampNote: false,
			allowExpand: false,
			showContextMenuDeleteButton: false,
			showUserNameColumn: false,
			showOvertimesColumn: config.showOvertimesColumn,
			showTravellingTimesColumn: config.showTravellingTimesColumn
		});

		this.getCurrentTimeAccountVacationData(
			BrowserStorageSettings.getTimeAccountDashboardBalanceMode(TimeAccountBase.GROUP_TIME_ACCOUNT) || "TODAY",
			globals.userId
		);
		if (globals.validateWorkingTime || globals.validateWorkingTimeOverlaps) {
			this.validateWorkingTimes(null, globals.userId, false);
		}
	}

	/**
	 * Returns the userId of the current user for a time sheet preview
	 * @protected
	 * @returns {number} userId
	 */
	protected getPreviewTimeSheetUserId(): number {
		return globals.userId;
	}

	private reloadCurrentTimeAccountData(): void {
		this.toggleMenuLoadingButton(false);
		this.toggleInitializedElements(false);
		const hasCurrentTimeAccountDataRequest = this.updateCurrentTimeAccountDataRequest != null;
		this.updateCurrentTimeAccountDataRequest?.abort();
		if (hasCurrentTimeAccountDataRequest) {
			TimeVacationAccountInfo.toggleTimeVacationAccountInfoPanelLoadingIndicator(false);
		}
		const hasValidateWorkingTimesRequest = this.updateValidateWorkingTimesRequest != null;
		this.updateValidateWorkingTimesRequest?.abort();
		if (hasValidateWorkingTimesRequest) {
			this.validationsCollapseComponent.toggleLoadingOverlay(false);
		}
		this.validationsCollapseComponent.reset();
		this.toggleMenuLoadingButton(false);
		if (globals.validateWorkingTime || globals.validateWorkingTimeOverlaps) {
			this.validateWorkingTimes(null, globals.userId, false);
		}
		this.getCurrentTimeAccountVacationData(BrowserStorageSettings.getTimeAccountDashboardBalanceMode(TimeAccountBase.GROUP_TIME_ACCOUNT), globals.userId);
	}

	protected showTimeAccountData(timeAccountData: TimeAccountVacationData) {
		super.showTimeAccountData(timeAccountData);

		this.toggleInitializedElements(!timeAccountData?.isInitialized);
	}

	protected onBalanceModeChanged(mode: TimeAccountDashboardBalanceMode) {
		BrowserStorageSettings.setTimeAccountDashboardBalanceMode(TimeAccountBase.GROUP_TIME_ACCOUNT, mode);
		this.getCurrentTimeAccountVacationData(mode, globals.userId);
		this.setPreviewTimeSheetDialogDate(mode);
		this.updateForwardPreviewDateButtonTitle(mode);
	}

	/**
	 * Displays a warning will displayed if the time account is not initialized
	 * If not, all other elements are hidden (table, time- and vacation container)
	 *
	 * @param showWarning
	 * @private
	 */
	private toggleInitializedElements(showWarning: boolean) {
		$("#timeAccountInitializedContent").toggle(!showWarning);
		$("#timeAccountNotInitializedValidation").toggle(showWarning);
	}
}
